import { Menu, Button, Text, type ButtonProps, useMantineTheme } from '@mantine/core';
import { useState } from 'react';

import { ArrowDropdown } from '../../icons';
import { SectionDropdownItems } from './SectionDropdown';

type Props = {
  sectionTitle: string
  sectionUid: string
  isSubsection: boolean
  canEdit: boolean
  isOnlyTopLevelSection: boolean
  handleOpenAddRequirement: (sectionUid: string) => void
  handleOpenDelete: (sectionUid: string) => void
  handleOpenRename: (sectionUid: string) => void
  handleOpenAddSubsection: (parentSectionUid: string) => void
} & ButtonProps;

const SectionTitleDropdown: React.FC<Props> = (props: Props) => {
  const [opened, setOpened] = useState(false);
  const { colors } = useMantineTheme();

  const {
    sectionTitle,
    sectionUid,
    canEdit,
    handleOpenAddRequirement,
    handleOpenDelete,
    handleOpenRename,
    handleOpenAddSubsection,
    isSubsection,
    isOnlyTopLevelSection,
    ...buttonProps
  } = props;

  if (!canEdit) {
    return <Text truncate fz={20} fw={500}>
      {sectionTitle}
    </Text>;
  }

  return (
    <Menu
      position='bottom-end'
      opened={opened}
      onChange={setOpened}
    >
      <Menu.Target>
        <Button
          rightSection={<ArrowDropdown color={colors.darkPurple[9]} />}
          p='0px 8px'
          variant='subtle'
          onClick={() => { setOpened((o) => !o); }}
          {...buttonProps}
        >
          <Text truncate fz={20} fw={500}>
            {sectionTitle}
          </Text>
        </Button>
      </Menu.Target>
      <Menu.Dropdown>
        <SectionDropdownItems
          isCurrentPage={true}
          isOnlyTopLevelSection={isOnlyTopLevelSection}
          openAddRequirement={() => { handleOpenAddRequirement(sectionUid); setOpened(false); }}
          openDelete={() => { handleOpenDelete(sectionUid); setOpened(false); }}
          openRename={() => { handleOpenRename(sectionUid); setOpened(false); }}
          openAddSubsection={() => { handleOpenAddSubsection(sectionUid); setOpened(false); }}
          isSubsection={isSubsection}
        />
      </Menu.Dropdown>
    </Menu>
  );
};

export default SectionTitleDropdown;
